import React from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import Translator from "Languages/Utility/Translator";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import BenefitTable from "./components/BenefitTable";

function Benefit() {
    return (
        <>
            <div className="project-section-head">
                <PageTitle title={<Translator id={"profit_and_loss_of_the_project"}/>} />
            </div>
            <MuiPaper className="border-top-0 overflow-hidden">
                <BenefitTable />
            </MuiPaper>
        </>
    );
}

export default Benefit;
